import { render } from "./AllExerciseSheetQuestionThemes.vue?vue&type=template&id=2481666a"
import script from "./AllExerciseSheetQuestionThemes.vue?vue&type=script&lang=js"
export * from "./AllExerciseSheetQuestionThemes.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__